import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

export const HeroSection = () => {
    const { t } = useTranslation();

    return (
        <section className="py-5 text-center bg-light">
            <Container>
                <h1 className="display-5 fw-bold">
                    {t('pages.dmarcChecker.lookup.title')}
                </h1>
                <p className="lead mt-3">
                    {t('pages.dmarcChecker.lookup.subTitle')}
                </p>
            </Container>
        </section>
    );
};
